import { getDynamicConfigs } from '@hungryroot/rest/api/v2/dynamic_configs/get';

export async function fetchFeatureFlagDefinitions<T extends readonly string[]>(
  names: T
) {
  return await getDynamicConfigs({
    name: names,
    limit: 1000,
  });
}
